export function formatNowForFilename(): string {
  const d = new Date();
  const yyyy = d.getFullYear();
  const MM = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  const safeColon = "꞉"
  return `${yyyy}.${MM}.${dd} ${hh}${safeColon}${mm}`;
}